import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IncidentForm } from '../../components/incidents/IncidentForm';

export const IncidentFormPage = ({ user }: { user: any }) => {
  const navigate = useNavigate();
  return (
    <div className="p-4 md:p-6">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white mb-1">Déclarer un incident</h1>
        <p className="text-gray-400 text-sm">Formulaire de signalement opérationnel DGSN</p>
      </div>
      <IncidentForm user={user} onSubmitted={() => navigate('/operations/incidents')} />
    </div>
  );
};
